<template>
  <div>
    <h2 class="mb-2 display-1">{{ $t("boutique.adresseLivraison") }}</h2>
    <v-alert type="error" text v-if="!loggedIn">{{ $t("boutique.dejaMembre") }}</v-alert>
    <v-form ref="mainForm">
      <v-row>
        <v-col cols="12" md="6" class="pb-0">
          <LoadingComponent :loading="loadingCatalogues">
            <v-autocomplete
              :items="catalogues.civilites"
              v-model="civilite"
              outlined
              :item-text="$i18n.locale"
              item-value="id"
              @change="updateAccount"
              :rules="required"
            >
              <template v-slot:label>{{ $t("infosPersonnelles.civilite") }} *</template>
            </v-autocomplete>
          </LoadingComponent>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field v-model="prenom" outlined @input="updateAccount" :rules="required">
            <template v-slot:label>{{ $t("infosPersonnelles.prenom") }} *</template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field v-model="nom" outlined @input="updateAccount" :rules="required">
            <template v-slot:label>{{ $t("infosPersonnelles.nom") }} *</template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field v-model="courriel" outlined @input="updateAccount" :rules="requiredEmail">
            <template v-slot:label>{{ $t("infosPersonnelles.courriel") }} *</template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field v-model="telephone" outlined v-facade="'### ### ####'" @input="updateAccount" :rules="required">
            <template v-slot:label>{{ $t("adresse.telephone") }} *</template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field v-model="adresse" outlined @input="updateAccount" :rules="required" id="adresse-field">
            <template v-slot:label>{{ $t("adresse.adresse") }} *</template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field v-model="ville" outlined @input="updateAccount" :rules="required">
            <template v-slot:label>{{ $t("adresse.ville") }} *</template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field v-model="codePostal" outlined v-facade="'A#A #A#'" @input="updateAccount" :rules="codePostalRules">
            <template v-slot:label>{{ $t("adresse.codePostal") }} *</template>
          </v-text-field>
        </v-col>

        <v-col cols="12" md="6" class="pb-0">
          <LoadingComponent :loading="loadingCatalogues">
            <v-autocomplete
              :items="catalogues.provinces"
              v-model="province"
              outlined
              :item-text="$i18n.locale"
              item-value="id"
              @change="updateAccount"
              :rules="required"
            >
              <template v-slot:label>{{ $t("adresse.province") }} *</template>
            </v-autocomplete>
          </LoadingComponent>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import Rules from "@/mixins/Rules"
import CataloguesLoader from "@/mixins/CataloguesLoader"
import PosteCanada from "@/mixins/PosteCanada"
import InfosPersonnellesModel from "@/mixins/InfosPersonnellesModel"
import AccountInfo from "@/components/common/AccountInfo"
import LoadingComponent from "@/components/common/LoadingComponent"
export default {
  mixins: [Rules, CataloguesLoader, PosteCanada, InfosPersonnellesModel],
  data() {
    return {
      cataloguesToLoad: ["civilites", "provinces"]
    }
  },
  components: {
    AccountInfo,
    LoadingComponent
  },
  computed: {
    ...mapGetters(["catalogues", "account", "loggedIn"])
  },
  methods: {
    ...mapMutations(["SET_ACCOUNT"]),
    updateAccount() {
      let account = {
        civilite: {
          id: this.civilite
        },
        nom: this.nom,
        prenom: this.prenom,
        courriel: this.courriel,
        langue: this.$i18n.locale,
        adresse: {
          telephone: this.telephone,
          adresse: this.adresse,
          ville: this.ville,
          province: {
            id: this.province
          },
          codePostal: this.codePostal
        }
      }
      this.SET_ACCOUNT(account)
    }
  }
}
</script>

<style>
</style>